import React, { Component } from 'react';
import { compose } from 'redux';
import { Row, Col, Popover, PopoverBody } from 'reactstrap';
import Button from 'components/buttons/Button';
import ExpandMoreIcon from 'mdi-react/ExpandMoreIcon';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import RenderFormInput from 'components/forms/RenderFormInput';
import { requiredValidator, handleBlur } from 'utils/validators';
import { numericality } from 'redux-form-validators';

class StepDurationForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    updateStep: PropTypes.func.isRequired,
    stepKey: PropTypes.number.isRequired,
    durationInDays: PropTypes.number.isRequired,
    prevDuration: PropTypes.number.isRequired,
    nextDuration: PropTypes.number.isRequired,
    disabled: PropTypes.bool,
  };

  static defaultProps= {
    disabled: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      isPopoverOpen: false,
    };
    this.mainModalRef = React.createRef();
  }

  togglePopover = () => {
    const { isPopoverOpen } = this.state;

    this.setState({
      isPopoverOpen: !isPopoverOpen,
    });
  }

  handleSubmit = (formData) => {
    const { updateStep, stepKey } = this.props;
    updateStep(formData, stepKey);
    this.mainModalRef.current.click();
  }

  render() {
    const {
      stepKey, durationInDays, handleSubmit, prevDuration, nextDuration, disabled,
    } = this.props;
    const { isPopoverOpen } = this.state;
    const firstStepValidationRule = nextDuration ? {
      int: true,
      '>=': 0,
      '<': nextDuration,
      msg: {
        '<': 'Day must be less than the next step.',
      },
    } : {
      int: true,
      '>=': 0,
    };
    const stepRangeValidationRule = nextDuration ? {
      int: true,
      '>': prevDuration,
      '<': nextDuration,
      msg: {
        '>': 'Day must be greater than the previous step.',
        '<': 'Day must be less than the next step.',
      },
    } : {
      int: true,
      '>': prevDuration,
      msg: {
        '>': 'Day must be greater than the previous step.',
      },
    };
    const stepValidationRule = stepKey === 0 ? firstStepValidationRule : stepRangeValidationRule;

    return (
      <React.Fragment>
        <span ref={this.mainModalRef} className="step__title__main">Step {stepKey + 1} - </span>
        <div id={`popover-step-${stepKey}`} className="step-duration">
          {durationInDays === 0 ?
            <span>First day</span> :
            <span>{durationInDays} days after step 1</span>
          }
          {!disabled && <span className="icon"><ExpandMoreIcon /></span>}
        </div>
        <Popover
          trigger="legacy"
          isOpen={isPopoverOpen}
          toggle={disabled ? () => {} : this.togglePopover}
          placement="bottom"
          target={`popover-step-${stepKey}`}
          className="popover__duration"
        >
          <PopoverBody>
            <form onSubmit={handleSubmit(this.handleSubmit)}>
              <Row>
                <Col xs="12">
                  <span className="grey">Days</span>
                </Col>
              </Row>
              <Row>
                <Col xs="6">
                  <Field
                    name="days"
                    label="Days"
                    component={RenderFormInput}
                    type="number"
                    onBlur={handleBlur}
                    validate={[requiredValidator, numericality(stepValidationRule)]}
                  />
                </Col>
                <Col xs="6">
                  <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                    size="large"
                  >
                    Save
                  </Button>
                </Col>
              </Row>
            </form>
          </PopoverBody>
        </Popover>
        {stepKey !== 0 && <span className="step__title__caption">If no reply</span>}
      </React.Fragment>
    );
  }
}

export default compose(reduxForm({}))(StepDurationForm);
